import * as sikdae from 'services/sikdae';

export const STAFF_GROUP_ALL_LIST = 'STAFF_GROUP_ALL_LIST';
export const SIKDAE_LIST = 'SIKDAE_LIST';
export const SIKDAE_STATUS_LIST = 'SIKDAE_STATUS_LIST';
export const SIKDAE_DETAIL = 'SIKDAE_DETAIL';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const SIKDAE_GIVE_DEDUCT = 'SIKDAE_GIVE_DEDUCT';
export const SIKDAE_EXCEL_CHECK = 'SIKDAE_EXCEL_CHECK';
export const SIKDAE_EXCEL_UPLOAD = 'SIKDAE_EXCEL_UPLOAD';
export const MEAL_STATUS_LIST = 'MEAL_STATUS_LIST';
export const MEAL_LIST = 'MEAL_LIST';
export const MEAL_REJECTION = 'MEAL_REJECTION';
export const MEAL_APPROVAL_ACCEPTER = 'MEAL_APPROVAL_ACCEPTER';
export const MEAL_ACCEPTER_MOD = 'MEAL_ACCEPTER_MOD';
export const MEAL_APPROVAL = 'MEAL_APPROVAL';
export const LIMIT_STORE_SEL = 'LIMIT_STORE_SEL';
export const SIKDAE_EXCEL_DOWLOAD = 'SIKDAE_EXCEL_DOWLOAD';
export const SIKDAE_EXCEL_UPDLOAD_CHECK = 'SIKDAE_EXCEL_UPDLOAD_CHECK';
export const SIKDAE_EXCEL_UPDLOAD = 'SIKDAE_EXCEL_UPDLOAD';
export const CHANGE_POLICY_HISTORY_SEL = 'CHANGE_POLICY_HISTORY_SEL';
export const SCHEDULE_START_DATE = 'SCHEDULE_START_DATE';

// 식대그룹 조회
export const StaffGroupAllSel = (params) => ({
  type: STAFF_GROUP_ALL_LIST,
  payload: {
    promise: sikdae.StaffGroupAllSel(params)
  }
});

// 식대내역 상태코드
export const SikdaeStatusList = () => ({
  type: SIKDAE_STATUS_LIST,
  payload: {
    promise: sikdae.SikdaeStatusList()
  }
});

// 식대내역 목록
export const SikdaeGivenList = (params) => ({
  type: SIKDAE_LIST,
  payload: {
    promise: sikdae.SikdaeGivenList(params)
  }
});

// 식대내역 상세
export const SikdaeGivenDetail = (id, params) => ({
  type: SIKDAE_DETAIL,
  payload: {
    promise: sikdae.SikdaeGivenDetail(id, params)
  }
});

// 지급예약 취소
export const CancelReservation = (id) => ({
  type: CANCEL_RESERVATION,
  payload: {
    promise: sikdae.CancelReservation(id)
  }
});

// 식권 신청 상태 코드
export const MealApprovalStatus = () => ({
  type: MEAL_STATUS_LIST,
  payload: {
    promise: sikdae.MealApprovalStatus()
  }
});

// 식권 신청 결재 승인자 등록
export const MealAccepterMod = (dIdx, params) => ({
  type: MEAL_ACCEPTER_MOD,
  payload: {
    promise: sikdae.MealAccepterMod(dIdx, params)
  }
});

// 식권 신청 결재 승인자
export const MealApprovalAccepterList = (dIdx, params) => ({
  type: MEAL_APPROVAL_ACCEPTER,
  payload: {
    promise: sikdae.MealApprovalAccepterList(dIdx, params)
  }
});

// 식권 신청 내역
export const MealApprovalList = (params) => ({
  type: MEAL_LIST,
  payload: {
    promise: sikdae.MealApprovalList(params)
  }
});

// 식권 신청 반려
export const RejectMeal = (params) => ({
  type: MEAL_REJECTION,
  payload: {
    promise: sikdae.RejectMeal(params)
  }
});

// 식권 신청 승인
export const ApproveMeal = (params) => ({
  type: MEAL_APPROVAL,
  payload: {
    promise: sikdae.ApproveMeal(params)
  }
});

// 식대 지급/차감
export const SikdaeGiveDeduct = (params) => ({
  type: SIKDAE_GIVE_DEDUCT,
  payload: {
    promise: sikdae.SikdaeGiveDeduct(params)
  }
});

// 식대 지급/차감 > 엑셀파일 업로드 체크
export const SikdaeExcelCheck = (params) => ({
  type: SIKDAE_EXCEL_CHECK,
  payload: {
    promise: sikdae.SikdaeExcelCheck(params)
  }
});

// 식대 지급/차감 > 엑셀파일 업로드
export const SikdaeExcelUpload = (params) => ({
  type: SIKDAE_EXCEL_UPLOAD,
  payload: {
    promise: sikdae.SikdaeExcelUpload(params)
  }
});

// 가맹점 제한 조회
export const LimitStoreSel = (params) => ({
  type: LIMIT_STORE_SEL,
  payload: {
    promise: sikdae.LimitStoreSel(params)
  }
});

// 식대 지급/차감 엑셀 다운로드
export const ExcelDownload = (params) => ({
  type: SIKDAE_EXCEL_DOWLOAD,
  payload: {
    promise: sikdae.ExcelDownload(params)
  }
});

// 식대 지급/차감 엑셀 업로드 체크
export const ExcelUploadCheck = (params) => ({
  type: SIKDAE_EXCEL_UPDLOAD_CHECK,
  payload: {
    promise: sikdae.ExcelUploadCheck(params)
  }
});

// 식대 지급/차감 엑셀 업로드
export const ExcelUpload = (params) => ({
  type: SIKDAE_EXCEL_UPDLOAD,
  payload: {
    promise: sikdae.ExcelUpload(params)
  }
});

// 식대정책 변경 내역
export const ChangePolicyHistorySel = (params) => ({
  type: CHANGE_POLICY_HISTORY_SEL,
  payload: {
    promise: sikdae.ChangePolicyHistorySel(params)
  }
});

// 권한 중에 schedule 권한이 있을 때 식대지급 start 시간 조회
export const ScheduleStartDate = (params) => ({
  type: SCHEDULE_START_DATE,
  payload: {
    promise: sikdae.ScheduleStartDate(params)
  }
});
